import {PopularRanking, Statistics} from "../../models/statistics";
import {Video, EditCaptionInfo, VideoCaption} from "../../models/video";
import ExVideoEvents from "../events/ExVideoEvents";

// 辞書情報取得開始
export const LoadAllContextPhrase = (language: string) =>
    ({
        type: ExVideoEvents.LoadAllContextPhraseStarted,
        language,
   } as const);

// 辞書情報取得完了
export const LoadAllContextPhraseComplete = (phrases: string[]) =>
    ({
        type: ExVideoEvents.LoadAllContextPhraseComplete,
        phrases,
   } as const);

// 辞書更新開始
export const UpdateContextPhrase = (language: string, phrases: string[]) =>
    ({
        type: ExVideoEvents.UpdateContextPhraseStarted,
        language,
        phrases,
   } as const);

// 辞書更新完了
export const UpdateContextPhraseComplete = (phrases: string[]) =>
    ({
        type: ExVideoEvents.UpdateContextPhraseComplete,
        phrases,
   } as const);

// 辞書更新失敗
export const UpdateContextPhraseFailed = (error: string) =>
    ({
        type: ExVideoEvents.UpdateContextPhraseFailed,
        error,
   } as const);

// ビデオSTT編集開始
export const EditVideoCaption = (caption: EditCaptionInfo) =>
    ({
        type: ExVideoEvents.EditVideoCaptionStarted,
        caption,
   } as const);

// ビデオSTT編集完了
export const EditVideoCaptionComplete = (updateCaption: VideoCaption) =>
    ({
        type: ExVideoEvents.EditVideoCaptionComplete,
        updateCaption,
   } as const);

// ビデオSTT編集失敗
export const EditVideoCaptionFailed = (error: string) =>
    ({
        type: ExVideoEvents.EditVideoCaptionFailed,
        error,
   } as const);

// ビデオSTT再実行開始
export const RerunSTT = (videoId: number, videoLanguage: string) =>
    ({
        type: ExVideoEvents.RerunSTTStarted,
        videoId, videoLanguage
   } as const);

// ビデオSTT再実行完了
export const RerunSTTComplete = () =>
    ({
        type: ExVideoEvents.RerunSTTComplete,
   } as const);

// ビデオSTT再実行失敗
export const RerunSTTFailed = (error: string) =>
    ({
        type: ExVideoEvents.RerunSTTFailed,
        error,
   } as const);

// ビデオSTT公開ステータス更新開始
export const UpdateCaptionPublicState = (
    userId: number,
    videoId: number,
    publicCaption: boolean,
    muteState: boolean
) =>
    ({
        type: ExVideoEvents.UpdateCaptionPublicStateStarted,
        userId,
        videoId,
        publicCaption,
        muteState,
   } as const);

// ビデオSTT公開ステータス更新完了
export const UpdateCaptionPublicStateComplete = () =>
    ({
        type: ExVideoEvents.UpdateCaptionPublicStateComplete,
   } as const);

// ビデオSTT公開ステータス更新失敗
export const UpdateCaptionPublicStateFailed = (error: string) =>
    ({
        type: ExVideoEvents.UpdateCaptionPublicStateFailed,
        error,
   } as const);

// ビデオ処理情報取得開始
export const LoadProcessStatus = (userId: number) =>
    ({
        type: ExVideoEvents.LoadProcessStatusStarted,
        userId,
   } as const);

// ビデオ処理情報取得完了
export const LoadProcessStatusComplete = (videos: Video[]) =>
    ({
        type: ExVideoEvents.LoadProcessStatusComplete,
        videos,
   } as const);

// ビデオ処理情報取得（定期）開始
export const LoadProcessStatusRepeat = (userId: number) =>
    ({
        type: ExVideoEvents.LoadProcessStatusRepeatStarted,
        userId,
   } as const);

// ビデオ処理情報取得（定期）完了
export const LoadProcessStatusRepeatComplete = (videos: Video[]) =>
    ({
        type: ExVideoEvents.LoadProcessStatusRepeatComplete,
        videos,
   } as const);

// ビデオ再生オプション取得開始
export const GetVideoOption = () =>
    ({
        type: ExVideoEvents.GetVideoOptionStarted,
   } as const);

// ビデオ再生オプション取得完了
export const GetVideoOptionComplete = (
    isPlay: boolean,
    isVisibleCaption: boolean,
    isMuted: boolean,
    viewPattern: number
) =>
    ({
        type: ExVideoEvents.GetVideoOptionComplete,
        isPlay,
        isVisibleCaption,
        isMuted,
        viewPattern,
   } as const);

// ビデオ再生オプション更新開始
export const UpdateVideoOption = (
    isPlay: boolean,
    isVisibleCaption: boolean,
    isMuted: boolean,
    viewPattern: number
) =>
    ({
        type: ExVideoEvents.UpdateVideoOptionStarted,
        isPlay,
        isVisibleCaption,
        isMuted,
        viewPattern,
   } as const);

// ビデオ再生オプション更新完了
export const UpdateVideoOptionComplete = () =>
    ({
        type: ExVideoEvents.UpdateVideoOptionComplete,
   } as const);

// 統計情報取得開始
export const LoadStatistics = (startDate: string, endDate: string) =>
    ({
        type: ExVideoEvents.LoadStatisticsStarted,
        startDate,
        endDate,
   } as const);

// 統計情報取得完了
export const LoadStatisticsComplete = (stats: Statistics) =>
    ({
        type: ExVideoEvents.LoadStatisticsComplete,
        stats,
   } as const);

// 統計情報更新開始
export const UpdateStatistics = (
    userId: number,
    videoId: number,
    videoTag: string,
    videoTitle: string,
    videoUrl: string,
    viewDurationMillis: number,
    newWatch: boolean
) =>
    ({
        type: ExVideoEvents.UpdateStatisticsStarted,
        userId,
        videoId,
        videoTag,
        videoTitle,
        videoUrl,
        viewDurationMillis,
        newWatch,
   } as const);

// 統計情報更新完了
export const UpdateStatisticsComplete = () =>
    ({
        type: ExVideoEvents.UpdateStatisticsComplete,
   } as const);

// 統計情報更新完了
export const UpdateStatisticsFailed = (error: string) =>
    ({
        type: ExVideoEvents.UpdateStatisticsFailed,
        error,
   } as const);

// 人気ランキング情報取得開始
export const LoadPopularRanking = (startDate: string, endDate: string) =>
    ({
        type: ExVideoEvents.LoadPopularRankingStarted,
        startDate,
        endDate,
   } as const);

// 人気ランキング情報取得完了
export const LoadPopularRankingComplete = (ranking: PopularRanking) =>
    ({
        type: ExVideoEvents.LoadPopularRankingComplete,
        ranking,
   } as const);
